import { useState, useCallback, useEffect } from 'react';

const useImg = ({
  imgSrc,
  defaultSrc
}: {
  imgSrc: string,
  defaultSrc: string,
}) => {
  const [picUrl, setPicUrl] = useState(imgSrc || defaultSrc);
  const onError = useCallback(() => {
    setPicUrl(defaultSrc)
  }, [defaultSrc])

  useEffect(() => {
    setPicUrl(imgSrc || defaultSrc)
  }, [imgSrc]);

  return {
    picUrl,
    onError
  }
}

export default useImg
